<template>
    <div class="insight-authors">
        {{ authorsStr }}
    </div>
</template>

<script>
    export default {
        props: {
            authors: {
                type: Array,
                default: () => [],
            },
            andSeparator: {
                type: String,
                required: true,
            },
        },
        computed: {
            authorsStr() {
                return this.authors.map(({ title }) => title).join(', ')
                    .replace(/, ([^,]*)$/, ` ${ this.andSeparator } $1`);
            },
        },
    };
</script>
